import { HTMLAttributes, TdHTMLAttributes, ThHTMLAttributes } from 'react';
import clsx from 'clsx';

export const Table = (p: HTMLAttributes<HTMLTableElement>) => (
  <table
    {...p}
    className={clsx('w-full min-w-0 text-sm', p.className)}
  />
);

export const Th = (p: ThHTMLAttributes<HTMLTableCellElement>) => (
  <th
    {...p}
    className={clsx(
      'border-b border-gray-200 px-3 py-2 text-left font-medium text-gray-600',
      p.className
    )}
  />
);

export const Td = (p: TdHTMLAttributes<HTMLTableCellElement>) => (
  <td
    {...p}
    className={clsx('border-b border-gray-100 px-3 py-2 align-top', p.className)}
  />
);
